<template>
  <div class="about-us">
    <section class="company-intro">
      <h2>{{ t('about.company_intro') }}</h2>
      <p>{{ t('about.company_desc') }}</p>
    </section>

    <section class="core-advantages">
      <h2>{{ t('about.core_advantages') }}</h2>
      <div class="advantages-container">
        <div class="advantage-item">
          <h3>{{ t('about.advantage_direct_supply_title') }}</h3>
          <p>{{ t('about.advantage_direct_supply_desc') }}</p>
        </div>
        <div class="advantage-item">
          <h3>{{ t('about.advantage_tech_leadership_title') }}</h3>
          <p>{{ t('about.advantage_tech_leadership_desc') }}</p>
        </div>
        <div class="advantage-item">
          <h3>{{ t('about.advantage_solution_support_title') }}</h3>
          <p>{{ t('about.advantage_solution_support_desc') }}</p>
        </div>
        <div class="advantage-item">
          <h3>{{ t('about.advantage_quick_response_title') }}</h3>
          <p>{{ t('about.advantage_quick_response_desc') }}</p>
        </div>
      </div>
    </section>

    <section class="main-products">
      <h2>{{ t('about.main_products') }}</h2>
      
      <div class="product-category">
        <h3>{{ t('about.mosfet_series_title') }}</h3>
        <ul>
          <li>{{ t('about.mosfet_low_voltage') }}</li>
          <li>{{ t('about.mosfet_high_voltage') }}</li>
        </ul>
      </div>
      
      <div class="product-category">
        <h3>{{ t('about.dcdc_chips_title') }}</h3>
        <p>{{ t('about.dcdc_chips_desc') }}</p>
      </div>
      
      <div class="product-category">
        <h3>{{ t('about.acdc_chips_title') }}</h3>
        <p>{{ t('about.acdc_chips_desc') }}</p>
      </div>
      
      <div class="product-category">
        <h3>{{ t('about.custom_services_title') }}</h3>
        <p>{{ t('about.custom_services_desc') }}</p>
      </div>
    </section>

    <section class="service-areas">
      <h2>{{ t('about.service_areas') }}</h2>
      <div class="areas-container">
        <div class="area-item">{{ t('about.area_industrial_control') }}</div>
        <div class="area-item">{{ t('about.area_new_energy') }}</div>
        <div class="area-item">{{ t('about.area_consumer_electronics') }}</div>
        <div class="area-item">{{ t('about.area_smart_home') }}</div>
      </div>
    </section>

    <section class="mission-vision">
      <h2>{{ t('about.mission_vision') }}</h2>
      <p>{{ t('about.mission_vision_desc') }}</p>
    </section>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'AboutUs',
  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style scoped>
.about-us {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

section {
  margin-bottom: 50px;
}

h2 {
  color: #2c3e50;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #42b983;
}

h3 {
  color: #42b983;
  margin-top: 0;
}

/* Core Advantages Section */
.advantages-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.advantage-item {
  flex: 1;
  min-width: 220px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* Main Products Section */
.product-category {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.product-category h3 {
  margin-top: 0;
  margin-bottom: 15px;
}

.product-category ul {
  padding-left: 20px;
}

.product-category li {
  margin-bottom: 8px;
}

/* Service Areas Section */
.areas-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.area-item {
  flex: 1;
  min-width: 200px;
  padding: 15px;
  background-color: #42b983;
  color: white;
  border-radius: 5px;
  text-align: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* Mission Vision Section */
.mission-vision {
  padding: 30px;
  background-color: #f9f9f9;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.mission-vision p {
  font-style: italic;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .advantages-container,
  .areas-container {
    flex-direction: column;
  }
  
  .advantage-item,
  .area-item {
    min-width: 100%;
  }
}
</style>